import { Component, createRef, ReactNode } from 'react';
import { EnvService, CacheService, IStorageLocal, NamingConvention, CookieService, FilterItem, FilterItemOperator } from 'namirasoft-core';
import { NSLayout, IBaseComponentProps, IHeaderIconProps, NSBarActionProps, NSBarNotificationProps, NSDialogDelete, NSBarAlertProps, NSLoading, IBackgroundProps, ProductCacheService, NSBarTitleProps, IHeaderRightProps } from 'namirasoft-site-react';
import { NamirasoftMessageServer } from 'namirasoft-message';
import { NSASectionEdit, NSASectionEditCustomProps } from './NSASectionEdit';
import { NSASectionView, NSASectionViewCutomProps } from './NSASectionView';
import { NSASectionList, NSASectionListCustomProps } from './NSASectionList';
import { Actions } from './Actions';
import { NSARouterMakerProps } from '../NSARouterMakerProps';
import { IEntityInfo } from '../IEntityInfo';
import { NSAProductListDialog } from '../components/NSAProductListDialog';
import { NSAWorkspaceListDialog } from '../components/NSAWorkspaceListDialog';
import { NSAAccessListDialog } from '../components/NSAAccessListDialog';
import { NSAMessageListDialog } from '../components/NSAMessageListDialog';
import { CategoryRow, FieldRow, NamirasoftFieldMetaDatabase, NamirasoftFieldServer } from 'namirasoft-field';
import { NamirasoftMap } from 'namirasoft-site-map';
import { NamirasoftAccountClient } from 'namirasoft-account-client';
import { ProductFullRow } from 'namirasoft-api-product';
import { UseParams } from '../UseParams';
import { IHeaderLeftProps } from 'namirasoft-site-react/dist/props/IHeaderLeftProps';

let REACT_APP_BASE_URL_ACCOUNT_CONSOLE = new EnvService("REACT_APP_BASE_URL_ACCOUNT_CONSOLE").getString();
let client = new NamirasoftAccountClient(REACT_APP_BASE_URL_ACCOUNT_CONSOLE);
client.onLoggedin = () => { window.location.reload(); };
client.onLoggedout = () => { window.location.reload(); };

export interface NSALayoutPagesProps<RowType extends { id: string }, RowTypeInput = RowType>
{
	entity: IEntityInfo<RowType, RowTypeInput>;
	ui?: {
		action?: {
			menus: {
				_new?: boolean;
				list?: boolean;
				view?: boolean;
				view_history?: boolean;
				copy?: boolean;
				edit?: boolean;
				delete?: boolean;
				apply?: boolean;
			};
		};
	}
	list?: NSASectionListCustomProps<RowType, RowTypeInput>;
	edit?: NSASectionEditCustomProps<RowType, RowTypeInput> & {
		ui: {
			action?: {
				menus: {
					apply?: boolean,
				}
			},
		}
	};
	view?: NSASectionViewCutomProps<RowType>;
}
export interface NSALayoutProps<RowType extends { id: string }, RowTypeInput = RowType> extends IBaseComponentProps, NSARouterMakerProps
{
	model?: {
		id: string | null;
	}
	custom?: {
		scope?: string;
		logo?: string;
		background?: IBackgroundProps;
	}
	header?: {
		right?: IHeaderRightProps;
		left?: IHeaderLeftProps;
		built_in?: {
			logout?: boolean;
			message?: boolean;
			access?: boolean;
			workspace?: boolean;
			product?: boolean;
		};
	};
	notifications: NSBarNotificationProps[];
	action?: NSBarActionProps;
	title?: NSBarTitleProps;
	alerts?: NSBarAlertProps[];
	pages?: NSALayoutPagesProps<RowType, RowTypeInput>;
	children: ReactNode;
}

interface NSALayoutState
{
	parmas: any | null;
	product: ProductFullRow | null;
	refresher: number;
	message_count: number;
	showDeleteDialog: boolean;
	showMessageListDialog: boolean;
	showAccessListDialog: boolean;
	showProductListDialog: boolean;
	showWorkspaceListDialog: boolean;
	ctf_enabled: boolean;
	ctf_categories: CategoryRow[] | null;
	ctf_fields: FieldRow[] | null;
}

export class NSALayout<RowType extends { id: string }, RowTypeInput = RowType> extends Component<NSALayoutProps<RowType, RowTypeInput>, NSALayoutState>
{
	private hasCFT: boolean;
	private isLoggedIn: boolean;
	private cache: CacheService<ProductFullRow>;
	private cache_fields: CacheService<{
		ctf_categories: CategoryRow[] | null;
		ctf_fields: FieldRow[] | null;
	}>;
	private cache_message: CacheService<number>;
	NSASectionList_Ref = createRef<NSASectionList<RowType, RowTypeInput>>();
	NSASectionEdit_Ref = createRef<NSASectionEdit<RowType, RowTypeInput>>();
	NSASectionView_Ref = createRef<NSASectionView<RowType, RowTypeInput>>();

	constructor(props: NSALayoutProps<RowType, RowTypeInput>)
	{
		super(props);

		// Account
		this.isLoggedIn = this.props.account?.token_manager?.exists() ?? false;

		// CFT
		this.hasCFT = false;
		if (this.props.pages?.entity)
			try
			{
				let namirasoft = new NamirasoftMap(this.props.account.token_manager, props.notifier.onError);
				let table = namirasoft.getByProductID(this.props.pages.entity.product_id).tables[this.props.pages.entity.name];
				this.hasCFT = table.hasFieldTables();
			} catch (error)
			{ }

		// Cache Product
		this.cache = ProductCacheService.get(this.props.product_id, console.error);

		// Cache Fields
		// todo this must be owner_id, otherwise switching between owners does not work correctly
		let user_id = this.props.account.token_manager.getUserData(x => x.id, "");
		let key_field = `ns-fields-${user_id}-${props.pages?.entity?.product_id ?? "*"}-${props.pages?.entity?.name ?? "*"}`;
		this.cache_fields = new CacheService<{
			ctf_categories: CategoryRow[] | null;
			ctf_fields: FieldRow[] | null;
		}>(key_field, new IStorageLocal(), 24 * 60, async () =>
		{
			let service = new CookieService(document.cookie, "ns-field-version");
			return (this.props.account?.token_manager?.getUserData(x => x.id, "") ?? "") + "" + service.getString();
		}, async () =>
		{
			let REACT_APP_BASE_URL_FIELD = new EnvService("REACT_APP_BASE_URL_FIELD", true).getString();
			let server = new NamirasoftFieldServer(REACT_APP_BASE_URL_FIELD, props.account.token_manager, props.notifier.onError);
			let ans: {
				ctf_categories: CategoryRow[] | null;
				ctf_fields: FieldRow[] | null;
			} = { ctf_categories: null, ctf_fields: null };
			if (this.props.pages)
			{
				let meta = new NamirasoftFieldMetaDatabase();
				try
				{
					let filters: FilterItem[] = [];
					filters.push(new FilterItem(meta.tables.category, meta.tables.category.columns.product_id, false, FilterItemOperator.all.equals, this.props.pages.entity.product_id));
					filters.push(new FilterItem(meta.tables.category, meta.tables.category.columns.entity, false, FilterItemOperator.all.equals, this.props.pages.entity.name));
					let res = await server.category.List(filters, null, null, []);
					ans.ctf_categories = res.rows;
				} catch (error)
				{
					ans.ctf_categories = [];
				}
				try
				{
					let filters: FilterItem[] = [];
					filters.push(new FilterItem(meta.tables.field, meta.tables.field.columns.product_id, false, FilterItemOperator.all.equals, this.props.pages.entity.product_id));
					filters.push(new FilterItem(meta.tables.field, meta.tables.field.columns.entity, false, FilterItemOperator.all.equals, this.props.pages.entity.name));
					let res = await server.field.List(filters, null, null, []);
					ans.ctf_fields = res.rows;
				} catch (error)
				{
					ans.ctf_fields = [];
				}
			}
			return ans;
		});
		// Cache Message
		this.cache_message = new CacheService<number>("ns-messsage-count", new IStorageLocal(), 15, async () => "1.0.0", async () =>
		{
			let REACT_APP_BASE_URL_MESSAGE = new EnvService("REACT_APP_BASE_URL_MESSAGE", true).getString();
			let server = new NamirasoftMessageServer(REACT_APP_BASE_URL_MESSAGE, this.props.account.token_manager, console.error);
			let res = await server.message.GetNewCount();
			return res.count;
		});
		this.cache_message.onExpired = () => { this.reloadMessageCount(false); };

		// State
		this.state = {
			parmas: null,
			product: null,
			refresher: 0,
			message_count: 0,
			showDeleteDialog: false,
			showMessageListDialog: false,
			showAccessListDialog: false,
			showProductListDialog: false,
			showWorkspaceListDialog: false,
			ctf_enabled: this.hasCFT,
			ctf_fields: null,
			ctf_categories: null,
		};
	}
	public reloadMessageCount(force: boolean) 
	{
		if (force)
			this.cache_message.del();
		this.cache_message.get().then(count =>
		{
			this.setState(prev => ({ ...prev, message_count: count }));
		}).catch(() => { });
	}

	override componentDidMount(): void
	{
		this.cache.get().then(product =>
		{
			this.setState(prev => ({ ...prev, product }));
		})

		if (this.hasCFT)
			if (this.props.pages?.entity)
			{
				this.cache_fields.get().then(res =>
				{
					this.setState(prev => { return { ...prev, ctf_categories: res.ctf_categories ?? [], ctf_fields: res.ctf_fields ?? [] } });
				});
			}

		if (this.isLoggedIn)
			this.reloadMessageCount(true);

		client.start();
	}
	override componentWillUnmount(): void
	{
		client.stop();
	}
	override render()
	{
		let id = this.props.model?.id ?? null;
		if (!id)
		{
			if (this.state.parmas === null)
				return <UseParams onLoaded={parmas =>
				{
					this.setState({ parmas });
				}} />;
			id = this.state.parmas.id;
		}

		const hideDeleteDialog = async () => { this.setState(prev => ({ ...prev, showDeleteDialog: false })); };
		const showDeleteDialog = async () => { this.setState(prev => ({ ...prev, showDeleteDialog: true })); };

		let icons: IHeaderIconProps[] = [];
		if (this.isLoggedIn)
			if (this.props.header?.built_in?.logout ?? true)
				icons.push({
					src: "https://static.namirasoft.com/image/concept/logout/white.svg", alt: "Logout", onClicked: () =>
					{
						client.logout();
					},
					tooltip: "Logout"
				});

		if (this.isLoggedIn)
		{
			if (this.props.header?.built_in?.message ?? true)
				icons.push({
					src: "https://static.namirasoft.com/image/namirasoft/message/logo/base.png", alt: "Message", onClicked: () =>
					{
						this.setState(prev => ({ ...prev, showMessageListDialog: true }));
					},
					children: <>
						{
							(
								this.state.showMessageListDialog &&
								<NSAMessageListDialog {...this.props}
									onClose={() => { this.setState(prev => ({ ...prev, showMessageListDialog: false })); }}
									onSeenAll={() =>
									{
										this.reloadMessageCount(true);
									}}
									onMessageClick={() =>
									{
										this.reloadMessageCount(true);
									}}
								/>
							)
						}
					</>,
					count: this.state.message_count,
					tooltip: "Message"
				});
		}
		if (this.isLoggedIn)
			if (this.props.header?.built_in?.access ?? true)
				icons.push({
					src: "https://static.namirasoft.com/image/namirasoft/access/logo/base.png", alt: "Access", onClicked: () =>
					{
						this.setState(prev => ({ ...prev, showAccessListDialog: true }));
					},
					children: <>
						{
							(this.state.showAccessListDialog) && <NSAAccessListDialog {...this.props} onClose={() =>
							{
								this.setState(prev => ({ ...prev, showAccessListDialog: false }));
							}} />
						}
					</>,
					tooltip: "Accsess"
				});
		if (this.isLoggedIn)
			if (this.props.header?.built_in?.workspace ?? true)
				icons.push({
					src: "https://static.namirasoft.com/image/namirasoft/workspace/logo/base.png", alt: "Workspace", onClicked: () =>
					{
						this.setState(prev => ({ ...prev, showWorkspaceListDialog: true }));
					},
					children: <>
						{
							(this.state.showWorkspaceListDialog) && <NSAWorkspaceListDialog {...this.props} onClose={() =>
							{
								this.setState(prev => ({ ...prev, showWorkspaceListDialog: false }));
							}} />
						}
					</>,
					tooltip: "Workspace List"
				});
		if (this.props.header?.built_in?.product ?? true)
			icons.push({
				src: "https://static.namirasoft.com/image/concept/product-list/white.svg", alt: "Product", onClicked: () =>
				{
					this.setState(prev => ({ ...prev, showProductListDialog: true }));
				},
				children: <>
					{
						(this.state.showProductListDialog) && <NSAProductListDialog {...this.props} onClose={() =>
						{
							this.setState(prev => ({ ...prev, showProductListDialog: false }));
						}} >
							<></>
						</NSAProductListDialog>
					}
				</>,
				tooltip: "Product List"
			});

		let name = "";
		if (this.props.pages)
			name = NamingConvention.lower_case_underscore.convert(this.props.pages.entity.name, NamingConvention.Pascal_Case_Space);

		let user_name = this.props.account?.token_manager?.getUserData(user => [user.first_name, user.last_name].filter(n => n).join(" "), "") ?? "";

		let getIDs: (() => string[]) | null = null;
		let getRows: (() => RowType[]) | null = null;
		if (this.props.pages?.list)
		{
			getIDs = () => { return this.NSASectionList_Ref.current?.getSelectedIDs() ?? []; };
			getRows = () => { return this.NSASectionList_Ref.current?.getSelectedRows() ?? []; };
		}
		if (this.props.pages?.edit)
		{
			getIDs = () => [id].filter(id => id) as string[];
			getRows = () => [this.NSASectionEdit_Ref.current?.getRow()].filter(row => row) as RowType[];
		}
		if (this.props.pages?.view)
		{
			getIDs = () => [id].filter(id => id) as string[];
			getRows = () => [this.NSASectionView_Ref.current?.getRow()].filter(row => row) as RowType[];
		}

		let action: NSBarActionProps | undefined = { title: "", description: "", menus: {} };
		if (this.props.action?.title)
			action.title = this.props.action.title;
		if (this.props.action?.description)
			action.description = this.props.action.description;
		if (this.props.action?.menus != null)
			action.menus = { ...this.props.action?.menus };

		if (getIDs && getRows)
			if (this.props.pages?.entity.client.getMenus)
			{
				let menus = this.props.pages?.entity.client.getMenus(getIDs, getRows);
				for (let key of Object.keys(menus))
				{
					if (!action.menus)
						action.menus = {};
					if (!action.menus[key])
						action.menus[key] = [];
					action.menus[key].push(...menus[key]);
				}
			}

		let name_apply = "Apply";
		let name_actions = "Actions";
		if (!action.menus)
			action.menus = {};
		action.menus[name_apply] = [];
		action.menus[name_actions] = [];

		if (this.props.pages?.edit)
		{
			if (!action.title)
				action.title = (this.props.pages.edit.isEdit ? "Edit" : "New") + " " + name;

			// Menu
			if (this.props.pages.edit.ui.action?.menus.apply ?? true)
				action.menus[name_apply].push(Actions.apply({
					action: (onFinished) =>
					{
						if (this.props.pages?.edit)
							this.NSASectionEdit_Ref.current?.onApply(onFinished);
					}
				}));
		}
		else if (this.props.pages)
		{
			if (this.props.pages.entity.client.getNewURL)
				if (this.props.pages.entity.server.create)
					if (this.props.pages.ui?.action?.menus._new ?? true)
						action.menus[name_apply].push(Actions._new(this.props, this.props.pages.entity));
		}

		if (getIDs)
			if (this.props.pages)
			{
				if (this.props.pages.entity.client.getListURL)
					if (this.props.pages.entity.server.list)
						if (this.props.pages.ui?.action?.menus.list ?? true)
							action.menus[name_actions].push(Actions.list(this.props, this.props.pages.entity));

				if (this.props.pages.entity.client.getViewURL)
					if (this.props.pages.entity.server.get)
						if (this.props.pages.ui?.action?.menus.view ?? true)
							action.menus[name_actions].push(Actions.view(this.props, this.props.pages.entity, getIDs));

				if (this.props.pages.ui?.action?.menus.view_history ?? true)
					action.menus[name_actions].push(Actions.viewHistory(getIDs));

				if (this.props.pages.entity.client.getCopyURL)
					if (this.props.pages.entity.server.create)
						if (this.props.pages.ui?.action?.menus.copy ?? true)
							action.menus[name_actions].push(Actions.copy(this.props, this.props.pages.entity, getIDs));

				if (this.props.pages.entity.client.getEditURL)
					if (this.props.pages.entity.server.update)
						if (this.props.pages.ui?.action?.menus.edit ?? true)
							action.menus[name_actions].push(Actions.edit(this.props, this.props.pages.entity, getIDs));

				if (this.props.pages.entity.server.delete)
					if (this.props.pages.ui?.action?.menus.delete ?? true)
						action.menus[name_actions].push(Actions.delete(getIDs, {
							action: showDeleteDialog,
							showLoading: false
						}));
			}

		let action_name = "";
		let content;
		if (this.props.pages?.list)
		{
			action_name = "List";
			content = <NSASectionList<RowType, RowTypeInput>
				ref={this.NSASectionList_Ref}
				{...this.props}
				{...this.props.pages.list}
				entity={this.props.pages.entity}
				onIDsChanged={() =>
				{
					this.setState(prev => ({ ...prev }));
				}}
				ctf={{
					enabled: this.state.ctf_enabled,
					categories: this.state.ctf_categories,
					fields: this.state.ctf_fields
				}}
				deleteFieldCache={() => { this.cache_fields.del(); }}
			/>;
		}
		else if (this.props.pages?.edit)
		{
			if (this.props.pages.edit.isEdit)
				action_name = "Edit";
			else
				action_name = "New";
			content = <>
				<NSASectionEdit
					ref={this.NSASectionEdit_Ref}
					{...this.props}
					{...this.props.pages.edit}
					entity={this.props.pages.entity}
					ctf={{
						enabled: this.state.ctf_enabled,
						categories: this.state.ctf_categories,
						fields: this.state.ctf_fields
					}}
					deleteFieldCache={() => { this.cache_fields.del(); }}
					onRowLoaded={(row) =>
					{
						this.setState(prev => ({ ...prev }), () =>
						{
							this.props.pages?.edit?.onRowLoaded?.(row);
						});
					}}
					model={{
						id,
						row: null
					}}
				>
					{this.props.children}
				</NSASectionEdit>
			</>;
		}
		else if (this.props.pages?.view)
		{
			action_name = "View";
			content = <NSASectionView
				ref={this.NSASectionView_Ref}
				{...this.props}
				{...this.props.pages.view}
				entity={this.props.pages.entity}
				ctf={{
					enabled: this.state.ctf_enabled,
					categories: this.state.ctf_categories,
					fields: this.state.ctf_fields
				}}
				deleteFieldCache={() => { this.cache_fields.del(); }}
				onRowLoaded={(row) =>
				{
					this.setState(prev => ({ ...prev }), () =>
					{
						this.props.pages?.view?.onRowLoaded?.(row);
					});
				}}
				model={{
					id,
					row: null
				}}
			/>;
		}
		else
			content = this.props.children;

		let fullname = "";
		if (this.props.pages?.entity.name)
		{
			let Name_Pascal_Space = NamingConvention.lower_case_underscore.convert(this.props.pages.entity.name, NamingConvention.Pascal_Case_Space);
			if (action_name === "List")
				fullname = Name_Pascal_Space + " " + action_name;
			else
				fullname = action_name + " " + Name_Pascal_Space;
		}

		if (!this.state.product)
			return <NSLoading />;

		let action_title = action?.title ?? "";
		if (!action_title)
			action_title = fullname;
		if (!action_title)
			action_title = this.state.product?.name

		let action_description = action?.description ?? "";
		if (!action_description)
			action_description = this.state.product?.description ?? "";

		let scope = this.props.custom?.scope ?? `${this.state.product.name} Console`;
		let logo = this.props.custom?.logo ?? this.state.product.logo ?? "";
		let background = this.props.custom?.background?.image ?? this.state.product.background ?? "";

		return (
			<NSLayout
				{...this.props}
				scope={scope}
				logo={logo}
				background={{ image: background, attachment: this.props.custom?.background?.attachment, size: this.props.custom?.background?.size }}
				header={{
					right: {
						title: [user_name, (this.props.header?.right?.title)].filter(x => x).join(" "),
						icons: [...icons, ...(this.props.header?.right?.icons ?? [])],
					},
					left: {
						title: this.props.header?.left?.title
					}
				}}
				action={{
					title: action_title,
					description: action_description,
					menus: action.menus
				}}
				isLoggedIn={this.props.account?.token_manager?.exists}
			>
				{
					this.state.showDeleteDialog &&
					<NSDialogDelete
						title={"Delete Confirmation"}
						description={`Are you sure you want to delete ${name}?`}
						onClose={hideDeleteDialog}
						onNo={{ action: hideDeleteDialog, showLoading: false }}
						show_as_code={false}
						onYes={{
							action: async (onFinished) =>
							{
								try
								{
									if (this.props.pages)
										if (getIDs)
										{
											let ids = getIDs();
											if (ids.length === 0)
												throw new Error("Nothing was found to delete.");
											if (this.props.pages.entity.server.delete)
												if (ids.length === 1)
												{
													await this.props.pages.entity.server.delete(ids[0]);
													this.props.notifier.onSuccess(`${name} was deleted successfully.`);

													if (this.props.pages?.list)
													{
														let table = this.NSASectionList_Ref.current?.NSTable_Main.current;
														if (table)
														{
															let selected_ids = table.getSelectedIDs();
															let selected_rows = table.getSelectedRows();
															selected_ids = selected_ids.filter(id => !ids.includes(id));
															selected_rows = selected_rows.filter(row => !ids.includes(row.id));
															table.setSelectedIDs(selected_ids, selected_rows);
															table.reload(null, null);
														}
													}
													else if (this.props.pages?.edit)
													{
														if (this.props.pages.entity.client.getListURL)
															this.props.url.redirect(this.props.pages.entity.client.getListURL(), {});
														else if (this.props.pages.entity.client.getViewURL)
															this.props.url.redirect(this.props.pages.entity.client.getViewURL(ids[0]), {});
													}
													else if (this.props.pages?.view)
													{
														if (this.props.pages.entity.client.getListURL)
															this.props.url.redirect(this.props.pages.entity.client.getListURL(), {});
													}
												}
												else
												{
													// todo support multiple ids deletion
													this.props.notifier.onError(new Error("Multiple deletion is not supported yet."));
												}
										}
								} catch (error: any)
								{
								}
								hideDeleteDialog();
								onFinished();
							}
						}}
					>
						<></>
					</NSDialogDelete>}
				{
					(!this.state.ctf_enabled || (this.state.ctf_fields && this.state.ctf_categories)) ?
						content
						:
						<NSLoading />
				}
			</NSLayout>
		);

	}
}